import { UseMutateFunction } from '@tanstack/react-query';

import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { exportAlarmManagementOran } from '@api/alarmManagement';

import { IExportDefaultDTO } from '@interfaces/common/defaultDTO';

import { ESnackbarTypes } from '@enums/common';

import { EXPORT_ALARM_HISTORY } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

interface IUseMutateExportActiveAlarmsFlexidasReturn {
	handlePreparingExport: UseMutateFunction<any, any, IExportDefaultDTO, any>;
	isLoadingExportAlarmManagementOran: boolean;
}

export const useMutateExportAlarmManagementOran = (): IUseMutateExportActiveAlarmsFlexidasReturn => {
	const dispatch = useAppDispatch();

	const {
		mutate,
		isLoading,
	} = useMutation<IExportDefaultDTO>({
		mutationKey: [EXPORT_ALARM_HISTORY],
		mutationFn: exportAlarmManagementOran,
		onSuccess: () => {
			dispatch(setSnackbar({
				message: responseMessages.exportStartingNotificationSuccess,
				type: ESnackbarTypes.success,
			}));
		},
		refetchOnWindowFocus: false,
	});

	return {
		handlePreparingExport: mutate,
		isLoadingExportAlarmManagementOran: isLoading,
	};
};
